import { Grid, Button } from '@material-ui/core';
import Context from 'context';
import React, { useContext } from 'react';
import { ChromePicker, ColorResult } from 'react-color';
import { Wrapper } from './ColorPicker.style';

type ColorPickerModalProps = {
  index: number;
  setActive: any;
};

const ColorPickerModal = ({ index, setActive }: ColorPickerModalProps) => {
  const { colors, setColors } = useContext(Context);

  const updateColors = (color: ColorResult, index: number) => {
    const newColor = [...colors];
    newColor[index] = color.hex;
    setColors(newColor);
  };
  const styles = {
    default: {
      picker: {
        width: '500px',
      },
    },
  };

  return (
    <Wrapper onClick={() => setActive(false)}>
      <Grid
        container
        direction='column'
        alignContent='center'
        alignItems='center'
        justify='center'
        style={{ height: '100%' }}
      >
        <Grid item>
          <ChromePicker
            color={colors[index]}
            onChange={(color) => updateColors(color, index)}
            styles={styles}
          />
        </Grid>
        <Grid item>
          <br />
          <Button
            fullWidth
            variant='contained'
            onClick={() => setActive(false)}
            color='secondary'
          >
            ปิด
          </Button>
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default ColorPickerModal;
